import React, { createContext, useState } from 'react'
import { GrowthContent } from '@mc/api'
import { type CourseTile } from '../types'
import { TrailerModal } from './TrailerModal'

export interface VideoContextProps {
  isModalOpen: boolean
  currentContent: CourseTile | GrowthContent | null
  openVideo: (course: CourseTile | GrowthContent) => void
  closeVideo: (source?: string, event?: Event | React.SyntheticEvent) => void
}

export const VideoContext = createContext<VideoContextProps>({
  isModalOpen: false,
  openVideo: () => {},
  closeVideo: () => {},
  currentContent: null,
})

type ContentType = CourseTile | GrowthContent | null

type ProviderProps = {
  children?: React.ReactNode
  onModalClose?: (source?: string, content?: ContentType) => void
  onModalOpen?: (content?: ContentType) => void
}

export const VideoModalContextProvider = ({
  children,
  onModalClose,
  onModalOpen,
}: ProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentContent, setCurrentContent] = useState<ContentType>(null)

  const openVideo = (course: CourseTile | GrowthContent) => {
    setIsModalOpen(true)
    setCurrentContent(course)
    onModalOpen?.(course)
  }

  const closeVideo = (source?: string) => {
    setIsModalOpen(false)
    setCurrentContent(null)
    onModalClose?.(source, currentContent)
  }

  return (
    <VideoContext.Provider
      value={{
        isModalOpen,
        currentContent,
        openVideo,
        closeVideo,
      }}
    >
      {children}
      <TrailerModal />
    </VideoContext.Provider>
  )
}
